/// <reference path="../../Common/Helpers/GridEditorDialog.ts" />

namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class CartProductsEditDialog extends Common.GridEditorDialog<CartProductsRow> {
        protected getFormKey() { return CartProductsForm.formKey; }
        protected getLocalTextPrefix() { return CartProductsRow.localTextPrefix; }

        protected form = new CartProductsForm(this.idPrefix);
        public stateIds: number;
        public FranchiseeId: number;
        public OrderStatus: number;
        constructor() {
            super();           
            
        }

       
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            buttons.splice(0, 3)
            buttons.push({
                title: 'Remove Product From Cart',
                cssClass: 'delete-button',
                /* icon: 'fa fa-lock text-green',*/
                onClick: () => {

                    var ProductId = this.form.ProductId;
                    var Id = this.entity.Id;
                    CartService.RemoveProductFromCart({
                        EntityId: Id
                    }, response => {
                        window.location.reload();
                       // this.re
                    });


                }
            });



            return buttons;
        }
       
       

      

    }
}